import {
    Check,
    ChevronDown,
    Globe,
    // Languages,
} from 'lucide-react'

import {
    Menu,
    MenuItem,
    MenuTrigger,
    Popover,
} from 'react-aria-components'

import {
    useTranslation,
} from 'react-i18next'

import { Button } from './button'

import {
    availableLocales,
    getLocaleMetadata,
} from '@/app/i18n/locale-registry'

export function LanguageSwitcher() {
    const {
        t,
        i18n,
    } = useTranslation()

    const currentLocale =
        getLocaleMetadata(
            i18n.resolvedLanguage ??
            i18n.language,
        )

    function changeLanguage(
        languageCode: string,
    ): void {
        void i18n.changeLanguage(
            languageCode,
        )
    }

    return (
        <MenuTrigger>
            <Button
                variant="ghost"
                size="small"
                className={[
                    'h-10 gap-2 px-2.5',
                    'text-(--color-muted-foreground)',
                    'hover:text-(--color-foreground)',
                ].join(' ')}
                aria-label={t(
                    'language.label',
                )}
            >
                <Globe
                    aria-hidden="true"
                    className="h-4 w-4" />
                {/* <Languages
                    aria-hidden="true"
                    className="h-4 w-4"
                /> */}

                <span className="text-sm font-medium">
                    {currentLocale.shortName}
                </span>

                <ChevronDown
                    aria-hidden="true"
                    className="h-3.5 w-3.5"
                />
            </Button>

            <Popover
                placement="bottom end"
                offset={8}
                className={[
                    'z-50 min-w-44',
                    'rounded-lg border',
                    'border-(--color-border)',
                    'bg-(--color-surface)',
                    'p-1 shadow-(--shadow-popover)',
                    'outline-none',
                ].join(' ')}
            >
                <Menu
                    aria-label={t(
                        'language.label',
                    )}
                    onAction={(key) => {
                        changeLanguage(
                            String(key),
                        )
                    }}
                    className="outline-none"
                >
                    {availableLocales.map(
                        (locale) => {
                            const isCurrent =
                                locale.metadata.code ===
                                currentLocale.code

                            return (
                                <MenuItem
                                    key={
                                        locale.metadata.code
                                    }
                                    id={
                                        locale.metadata.code
                                    }
                                    textValue={
                                        locale.metadata
                                            .displayName
                                    }
                                    className={[
                                        'flex cursor-pointer',
                                        'items-center gap-3',
                                        'rounded-md px-3 py-2',
                                        'text-sm outline-none',
                                        'data-focused:bg-(--color-surface-muted)',
                                        'data-focused:text-(--color-foreground)',
                                    ].join(' ')}
                                >
                                    <span className="flex h-4 w-4 items-center justify-center">
                                        {isCurrent ? (
                                            <Check
                                                aria-hidden="true"
                                                className="h-4 w-4 text-(--color-primary)"
                                            />
                                        ) : null}
                                    </span>

                                    <span className="flex-1">
                                        {
                                            locale.metadata
                                                .displayName
                                        }
                                    </span>

                                    <span className="text-xs text-(--color-muted-foreground)">
                                        {
                                            locale.metadata
                                                .shortName
                                        }
                                    </span>
                                </MenuItem>
                            )
                        },
                    )}
                </Menu>
            </Popover>
        </MenuTrigger>
    )
}
